import { z } from "zod";

export const patchProjectSchema = z.object({
	projectId: z.string().min(1),
});
